<template>
  <div class="options-item" @click="handleClickItem">
    <i style="width: 30.38px;height: 30.38px;" :class="['icon', classIcon]"></i>
    <div class="title">{{ textTitle }}</div>
    <span v-if="badge" :class="['badge', 'badge-' + badge.variant]">{{ badge.text }}</span>
    <i class="icon fa-solid fa-angle-right arrow" v-show="showArrow"></i>
  </div>
</template>
<script>
export default {
  name: "OptionsItem",
  data() {
    return {};
  },
  components: {},
  updated() {},
  mounted() {},
  methods: {

    handleClickItem() {
      //alert("子層內建事件");
      this.$emit("clickItem"); // 再通知父層
    }

  },
  props: {
    //標題
    textTitle: {
      type: String,
      default: ""
    },
    //左方圖示
    classIcon:{
      type: String,
      default: "fa-solid fa-trash"
    },
    //右方指標是否呈現
    showArrow: {
      type: Boolean,
      default: false
    },
    //徽章（狀態標籤）
    badge: {
      type: Object,
      default: null
      // 格式：{ text: '已啟用', variant: 'success' }
      // variant 可選：success, warning, danger, info, secondary
    }
  },
};
</script>

<style scoped>
.options-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.options-item .title {
  flex: 1;
}

.badge {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 12px;
  white-space: nowrap;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-danger {
  background-color: #dc3545;
  color: white;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}
</style>
